export const SCRIPTS_MAP = {
    SUBSCRIPT: { element: 'sub' },
    SUPERSCRIPT: { element: 'sup' }
};
